import { lazy } from 'react';

import IRoute from 'Shared/Routes/Models/IRoute';

import { MosaferatiPaths } from './MosaferatiPaths';

const MosaferatiBimehNamehDetailPage = lazy(() => import('../../Detail/Pages/MosaferatiBimehNamehDetailPage'));
const ElhaghiyehHayeSaderehMosaferatiPage = lazy(
  () => import('../../ElhaghiyehHayeSadereh/Pages/ElhaghiyehHayeSaderehMosaferatiPage')
);
const ElhaghiyehSaderehDetailPage = lazy(
  () => import('../../ElhaghiyehSaderehDetail/Pages/ElhaghiyehSaderehDetailPage')
);
const MosaferatiEstelamPage = lazy(() => import('../../Estelam/Pages/MosaferatiEstelamPage'));

const MosaferatiRoutes: IRoute[][] = [
  [
    {
      path: MosaferatiPaths.BimehNameh.Estelam,
      component: MosaferatiEstelamPage,
      needAuth: false,
    },
    {
      path: MosaferatiPaths.BimehNameh.Detail,
      component: MosaferatiBimehNamehDetailPage,
      needAuth: true,
    },
    {
      path: MosaferatiPaths.BimehNameh.ElhaghiyehHayeSadereh,
      component: ElhaghiyehHayeSaderehMosaferatiPage,
      needAuth: true,
    },
    {
      path: MosaferatiPaths.BimehNameh.ElhaghiyehSaderehDetail,
      component: ElhaghiyehSaderehDetailPage,
      needAuth: true,
      parameters: ['gharardadBimehId'],
    },
  ],
];

export default MosaferatiRoutes;
